module.exports = __webpack_public_path__ + "static/colouring_in_bernard_thumb_2-adfb28e9b3f300a7f57855427e6708df.jpg";